import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Row, Col, Typography, Spin, Button } from 'antd';
import { withTranslation } from 'react-i18next';
import adminI18n from '../../i18n/adminI18n';
import JSONView from 'react-json-view';
import './GuestLoginLogModal.css';

const { Text } = Typography;

@inject(
    'GuestLoginLogStore'
)
@observer
class GuestLoginLogModalPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false
        }
    }

    componentDidMount() {
    }

    // ON CLICK

    cancelGuestLoginLogDetailOnClick = () => {
        this.props.GuestLoginLogStore.setshowGuestLoginLogModal(false);
    }

    render() {
        const { t } = this.props;
        const {
            guestLoginLog,
            guestLoginLogModalLoading
        } = this.props.GuestLoginLogStore;

        return (
            <>
                {
                    guestLoginLog
                        ?
                        <>
                            <Spin spinning={guestLoginLogModalLoading}>
                                <Row className='guestLoginlogmodal-row-container'>
                                    <Col span={24} className='guestLoginlogmodal-col'>
                                        <Row>
                                            <Col span={8} className='guestLoginlogmodal-col-label'>
                                                <Text className='guestLoginlogmodal-text-label'>{t('Area')}</Text>
                                            </Col>
                                            <Col span={16} className='guestLoginlogmodal-col-input'>
                                                <span>{guestLoginLog.area}</span>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={24} className='guestLoginlogmodal-col'>
                                        <Row>
                                            <Col span={8} className='guestLoginlogmodal-col-label'>
                                                <Text className='guestLoginlogmodal-text-label'>{t('Action')}</Text>
                                            </Col>
                                            <Col span={16} className='guestLoginlogmodal-col-input'>
                                                <span>{guestLoginLog.action}</span>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={24} className='guestLoginlogmodal-col'>
                                        <Row>
                                            <Col span={8} className='guestLoginlogmodal-col-label'>
                                                <Text className='guestLoginlogmodal-text-label'>{t('Username')}</Text>
                                            </Col>
                                            <Col span={16} className='guestLoginlogmodal-col-input'>
                                                <span>{guestLoginLog.username}</span>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={24} className='guestLoginlogmodal-col'>
                                        <Row>
                                            <Col span={8} className='guestLoginlogmodal-col-label'>
                                                <Text className='guestLoginlogmodal-text-label'>{t('Created At')}</Text>
                                            </Col>
                                            <Col span={16} className='guestLoginlogmodal-col-input'>
                                                <span>{guestLoginLog.createdDateString}</span>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={24} className='guestLoginlogmodal-col'>
                                        <Row>
                                            <Col span={8} className='guestLoginlogmodal-col-label'>
                                                <Text className='guestLoginlogmodal-text-label'>{t('Detail')}</Text>
                                            </Col>
                                            <Col span={16} className='guestLoginlogmodal-col-input json-viewer'>
                                                <JSONView src={JSON.parse(guestLoginLog.data)} />
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={24} className='guestLoginlogmodal-col-button'>
                                        <Button type='primary' className='guestLoginlogmodal-button' onClick={this.cancelGuestLoginLogDetailOnClick}>{t('Close')}</Button>
                                    </Col>
                                </Row>
                            </Spin >
                        </>
                        :
                        null
                }
            </>
        )
    }
}

export default withTranslation(undefined, { i18n: adminI18n })(GuestLoginLogModalPage);